export const getAddDoctorInitialValues = () => {
    return {
        doctor_name: "",
        designation: "",
        training_status: "",
        phone_number: "",
        email: "",
        hpr_id: "",
        reg_number: "",
        reg_year: "",
        state_lgd: "",
        insource_outsource: "Insource", // Default to Insource
        visiting_from: "",
    };
};